import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { EllipsisDropdownItem } from "@similarweb/ui-components";

import { FlexRow, LeftFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const CreateActivationSetCTAContainer = styled(FlexRow)<{ isDisabled: boolean }>`
    padding: 8px 0;
    height: 32px;
    align-items: center;
    border-top: 1px solid ${colorsPalettes.carbon[50]};
    cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
`;

export const ActivionSetItemContainer = styled(EllipsisDropdownItem)`
    &:hover {
        background-color: ${colorsPalettes.bluegrey[100]};
    }
`;

export const ActivionSetItemContent = styled(FlexRow)`
    > *:not(:last-child) {
        margin-right: 8px;
    }
`;

export const PrimaryDomain = styled.div`
    ${setFontVariant("input2", colorsPalettes.carbon[500])}
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
export const Count = styled.div`
    ${setFontVariant("input2", colorsPalettes.carbon[300])}
`;

export const NoSetsCreated = styled(LeftFlexRow)`
    ${setFontVariant("input2", colorsPalettes.carbon[300])}
    align-items: center;
    justify-content: flex-start;
    padding: 16px;
`;
